import {
  BookIcon,
  CameraIcon,
  CodeIcon,
  FlaskConicalIcon,
  FolderIcon,
  GlobeIcon,
  HeartIcon,
  MusicIcon,
  PaletteIcon,
  RocketIcon,
  StarIcon,
  TerminalIcon,
} from "lucide-react";
import { useState } from "react";
import { PROJECT_ICON_NAMES } from "@afar-research/contracts/settings";

const icons = {
  folder: FolderIcon,
  code: CodeIcon,
  terminal: TerminalIcon,
  globe: GlobeIcon,
  rocket: RocketIcon,
  book: BookIcon,
  flask: FlaskConicalIcon,
  heart: HeartIcon,
  star: StarIcon,
  music: MusicIcon,
  camera: CameraIcon,
  palette: PaletteIcon,
} satisfies Record<(typeof PROJECT_ICON_NAMES)[number], typeof FolderIcon>;

export function ProjectIcon({
  icon,
  className = "size-4",
}: {
  icon?: string | undefined;
  className?: string | undefined;
}) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (icon?.startsWith("emoji:"))
    return (
      <span
        aria-hidden="true"
        className={`inline-flex shrink-0 items-center justify-center leading-none ${className}`}
      >
        {icon.slice(6)}
      </span>
    );
  const name = PROJECT_ICON_NAMES.find((name) => icon === `icon:${name}`);
  const Icon = name ? icons[name] : undefined;
  if (Icon) return <Icon className={className} />;
  if (icon?.startsWith("data:image/") && failedSource !== icon)
    return (
      <img
        src={icon}
        alt=""
        className={`shrink-0 rounded-sm object-contain ${className}`}
        onError={() => setFailedSource(icon)}
      />
    );
  return <FolderIcon className={className} />;
}
